import React, { useContext, useEffect, useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { VerifiedCardIcon } from '../../../assets/icons/VerifiedCardIcon'
import { Context } from '../../../Store'
import { CardPaymentType } from './PaymentType/CardPaymentType'
import { SelectPaymentType } from './PaymentType/SelectPaymentType'
import { BOOKING_STATUS, PAYMENT_TYPE } from '../../../constants'
import { BankTransferPaymentType } from './PaymentType/BankTransferPaymentType'
import ChangePaymentMethodBanner from '../../ChangePaymentMethodBanner'
import { UserContext } from '../../../utils/UserContext'
import crypto from 'crypto'

export const Payment = () => {
  const { user = {} } = useContext(UserContext)
  const [adbSub, setAdbSub] = useState(null)
  const [{ payment_type, booking }] = useContext(Context)
  const { t } = useTranslation()

  useEffect(() => {
  const handlePageShow = (event) => {
    const navigationType = performance.getEntriesByType('navigation')[0]?.type

    // If the page was restored from bfcache or user hit "back"
    if (event.persisted || navigationType === 'back_forward') {
      console.log('page was restored from bfcache or user hit "back"')
      window.location.reload()
    }
  }
  window.addEventListener('pageshow', handlePageShow)

  return () => {
    window.removeEventListener('pageshow', handlePageShow)
  }
}, [])

  useEffect(() => {
    if (user.email) {
      var md5sum = crypto.createHash('md5')
      const md5 = md5sum.update(user.email).digest('hex')
      setAdbSub(md5)
    }
  }, [user])

  return (
    <>
      {adbSub && (
        <img
          src={`https://tracking.adgoon.it/GL1rQ?adv_sub=${adbSub}`}
          width="1"
          height="1"
          style={{
            display: 'none',
          }}
        />
      )}
      <Grid item xs={12} lg={11}>
        <Typography variant="subtitle1">{t('booking.paymentInfo.typePayment.title')}</Typography>
      </Grid>
      <Grid item xs={12} lg={11}>
        <div className="flex items-center" style={{ marginBottom: '0.625rem', gap: '0.625rem' }}>
          <VerifiedCardIcon fill="#0C9D9D" width="2.5rem" height="1.9338rem" />
          <Typography style={{ fontWeight: 400, fontSize: '1rem', color: '#757575', margin: 0 }}>
            {t('booking.paymentInfo.typePayment.confidentText')}
          </Typography>
        </div>
      </Grid>
      <SelectPaymentType />

      {booking.status === BOOKING_STATUS.PENDING && <ChangePaymentMethodBanner bookingId={booking.id} />}

      {payment_type === PAYMENT_TYPE.CARD && booking.status === BOOKING_STATUS.DRAFT && (
        <>
          <CardPaymentType />
        </>
      )}

      {payment_type === PAYMENT_TYPE.BANK_TRANSFER && booking.status === BOOKING_STATUS.DRAFT && (
        <>
          <BankTransferPaymentType />
        </>
      )}
    </>
  )
}
